<section
	class="w-full rounded-[30px] border border-mainColorLight bg-white p-4 shadow-[0_4px_14px_rgba(15,23,42,0.06)] md:p-5"
>
	<header class="mb-4">
		@if (isMultiChoiceHeader) {
			@let count = multiChoiceCount$ | async;
			@let c = count ?? 0;
			<div class="flex items-center gap-3">
				<div
					class="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] bg-mainColorHoverBg text-mainColor"
				>
					<i [class]="iconClass + ' text-lg'" aria-hidden="true"></i>
				</div>
				<div class="flex min-w-0 flex-1 flex-wrap items-center justify-between gap-x-3 gap-y-1.5">
					<div class="flex min-w-0 flex-wrap items-center gap-2">
						<h3 class="text-mainColor text-xl font-bold leading-snug">
							{{ title }}
						</h3>
						@if (c > 0) {
							<span
								class="inline-flex h-6 min-w-[1.5rem] shrink-0 items-center justify-center rounded-full bg-accentColorBg15 px-2 text-sm font-bold leading-none text-mainColor"
							>
								{{ c }}
							</span>
						}
					</div>
					@if (c > 0) {
						<button
							type="button"
							class="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium leading-none text-gray transition hover:text-mainColor"
							(click)="clearMultiChoice($event)"
						>
							<i class="fa-solid fa-xmark text-xs" aria-hidden="true"></i>
							wyczyść
						</button>
					}
				</div>
			</div>
		} @else {
			<div class="flex items-center gap-3">
				<div
					class="flex h-11 w-11 shrink-0 items-center justify-center rounded-[14px] bg-mainColorHoverBg text-mainColor"
				>
					<i [class]="iconClass + ' text-lg'" aria-hidden="true"></i>
				</div>
				<h3 class="min-w-0 text-mainColor text-xl font-bold leading-snug">
					{{ title }}
				</h3>
			</div>
		}
	</header>

	<div class="min-h-8 rounded-xl bg-white">
		<ng-content></ng-content>
	</div>
</section>
